// extracted by mini-css-extract-plugin
export default {"verticalVideoWrapper":"verticalVideoWrapper-OF6pA","horizontalVideoWrapper":"horizontalVideoWrapper-E1Gr7","thumbnail":"thumbnail-z6oJ2"};